export default "__VITE_ASSET__bbbe546a__"